module.exports = __webpack_public_path__ + "img/tips-personal-icon.b4853874.svg";